import i18next from "i18next";
import { UserType } from "@/api-schema-enums";

const USER_TYPE_TRANSLATION_KEYS: Record<UserType, string> = {
  Employee: "masterdata:Employee",
  Guest: "masterdata:Guest",
} satisfies Record<UserType, string>;

export function renderUserType(type: UserType): string {
  const key = USER_TYPE_TRANSLATION_KEYS[type];
  if (key) return i18next.t(key);
  return i18next.t("masterdata:UnknownType", { type });
}
